import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import shortid from "shortid";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { useForm } from "react-hook-form";
import { getAllCategories } from '../../../redux/categoriesRedux';
import { useSelector } from 'react-redux';
import { capitalizeFirstLetter } from '../../../utils/capFirstLetter';
import { isQuillEmpty } from '../../../utils/isQuillEmpty';

const PostForm = (props) => {

  const { register, handleSubmit: validate, formState: { errors }, reset: resetForm } = useForm();

  const initialPostState = {
    id: props.id || shortid(),
    title: props.title || '',
    author: props.author || '',
    publishedDate: props.publishedDate || '',
    category: props.category || '',
    shortDescription: props.shortDescription || '',
    content: props.content || '',
  };

  const [post, setPost] = useState(initialPostState);
  const [contentError, setConErr] = useState(false);
  const [dateError, setDateErr] = useState(false);
  const [categoryError, setCategoryError] = useState(false);

  const categories = useSelector(getAllCategories);

  const handleChange = (field, value) => {
    setPost(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    setConErr(isQuillEmpty(post.content));
    setDateErr(!post.publishedDate);
    setCategoryError(!post.category);

    if (!isQuillEmpty(post.content) && post.publishedDate && post.category) {
      props.action(post);
      setPost({
        id: shortid(),
        title: '',
        author: '',
        publishedDate: '',
        category: '',
        shortDescription: '',
        content: '',
      });
      resetForm();
    }
  };

  return (
    <Form onSubmit={validate(handleSubmit)}>
      <Form.Group className="mb-3">
        <Form.Label>Title</Form.Label>
        <Form.Control
          {...register("title", { required: true, minLength: 4 })}
          type="text"
          placeholder="Enter title"
          value={post.title}
          onChange={(e) => handleChange('title', e.target.value)}
        />
        {errors.title?.type === 'required' && <small className="d-block form-text text-danger mt-2">This field is required</small>}
        {errors.title?.type === 'minLength' && <small className="d-block form-text text-danger mt-2">Minimum length is 4</small>}
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Author</Form.Label>
        <Form.Control
          {...register("author", { required: true, minLength: 4 })}
          type="text"
          placeholder="Enter Author"
          value={post.author}
          onChange={(e) => handleChange('author', e.target.value)}
        />
        {errors.author?.type === 'required' && <small className="d-block form-text text-danger mt-2">This field is required</small>}
        {errors.author?.type === 'minLength' && <small className="d-block form-text text-danger mt-2">Minimum length is 4</small>}
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Published</Form.Label>
        <Form.Control
          type="date"
          value={post.publishedDate}
          onChange={(e) => handleChange('publishedDate', e.target.value)}
        />
        {dateError && <small className="d-block form-text text-danger mt-2">Date can't be empty</small>}
      </Form.Group>

      <Form.Group>
        <Form.Label>Categories</Form.Label>
        <Form.Select
          aria-label="Default select"
          value={post.category}
          onChange={(e) => handleChange('category', e.target.value)}
        >
          <option>Select category...</option>
          {categories.map(cat => 
            <option key={`cat-${cat}`} value={cat}>
              {capitalizeFirstLetter(cat)}
            </option>
          )}
        </Form.Select>
        {categoryError && <small className="d-block form-text text-danger mt-2">You must select category</small>}
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Short Description</Form.Label>
        <Form.Control
          {...register("shortDescription", { required: true, minLength: 19 })}
          as="textarea"
          rows={3}
          placeholder="Enter short description of post..."
          value={post.shortDescription}
          onChange={(e) => handleChange('shortDescription', e.target.value)}
        />
        {errors.shortDescription?.type === 'required' && <small className="d-block form-text text-danger mt-2">This field is required</small>}
        {errors.shortDescription?.type === 'minLength' && <small className="d-block form-text text-danger mt-2">Minimum length is 19</small>}
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Main Content</Form.Label>
        <style>{`
          .ql-editor {
            min-height: 200px;
          }
        `}</style>
        <ReactQuill value={post.content} onChange={(value) => handleChange('content', value)} />
        {contentError && <small className="d-block form-text text-danger mt-2">Content can't be empty</small>}
      </Form.Group>

      <Button variant="primary" type="submit">
        {props.actionText}
      </Button>
    </Form>
  );
};

export default PostForm;